import { Injectable } from '@angular/core';

declare let fbq: any;

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService {

  track(event: string, data?: any) {
    if (typeof fbq !== 'undefined') {
      fbq('track', event, data);
    }
  }

}
